import { useContext } from 'react'

import { AuthContext } from 'auth/context/useAuthContext'

export const useCharlieUser = () => {
  const { charlieUser } = useContext(AuthContext)

  return charlieUser!
}
